export const setJobs = (state, jobs) => {
  state.jobs = jobs;
};

export const setFavoriteLoading = (state, loading) => {
  state.favoriteLoading = loading;
};

export const setProfileData = (state, profileData) => {
  state.userInfo = profileData;
};

export const initRequest = state => {
  state.error = false;
  state.errorMessage = '';
  state.success = false;
  state.successMessage = '';
};

export const fetchRequest = state => {
  state.fetching = true;
};

export const finishRequest = state => {
  state.fetching = false;
};

export const setError = (state, { isError, errorMessage }) => {
  state.error = isError;
  state.errorMessage = errorMessage;
};

export const setSuccess = (state, { isSuccess, successMessage }) => {
  state.success = isSuccess;
  state.successMessage = successMessage;
};

export const setRequestResult = (state, response) => {
  state.requestResult = {
    status: response.success,
    statusColor: response.success ? 'success' : 'error',
    message: response.message,
    showMessage: true
  };
};

export const initRequestResult = state => {
  state.requestResult = {
    status: '',
    message: '',
    showMessage: false
  };
};

export const setInvalidTokenValue = (state, isInvalid) => {
  state.invalidToken = isInvalid;
};

export const setUserType = (state, userType) => {
  state.userType = userType;
};

export const setUserAuthError = (state, { isError, authErrorMessage }) => {
  state.authErrorMessage = authErrorMessage;
  state.authError = isError;
};

export const setUbication = (state, ubicationData) => {
  ubicationData.paises.sort((a, b) =>
    a.nombrePais > b.nombrePais ? 1 : b.nombrePais > a.nombrePais ? -1 : 0
  );
  ubicationData.departamentos.sort((a, b) =>
    a.departamento > b.departamento
      ? 1
      : b.departamento > a.departamento
        ? -1
        : 0
  );
  state.ubication = ubicationData;
};

export const setListaCarreras = (state, listaCarreras) => {
  state.carreras = listaCarreras;
};

export const setListaIndustrias = (state, listaIndustrias) => {
  state.industrias = listaIndustrias;
};

export const setResultadosGlobalesTest = (state, payload) => {
  state.resultadosGlobalesTest = payload;
};

export const setStateTest = (state, payload) => {
  state.stateTest = payload;
};

export const setNextQuestionTest = (state, payload) => {
  state.nextQuestionTest = payload;
};

export const setListaPublicaciones = (state, payload) => {
  state.listaPublicaciones = payload;
};

export const setPublicacionSeleccionada = (state, payload) => {
  state.publicacionSeleccionada = payload;
};
